import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InSetBoxShadow from "../../../../Common/InSetBoxShadow";
import Drawer from "@mui/material/Drawer";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import FilterIcon from "@mui/icons-material/Tune";
import SortIcon from "@mui/icons-material/FilterList";
import AccessLink from "../../../../Common/AccessLink";

const Sort = ({
  loading,
  count,
  handleFilter,
  getValue,
  toggleFilterDialog,
  filterDelete,
}) => {
  const { sort } = useSelector(state => state);
  const [sortDrawer, setSortDrawer] = useState(false);

  const toggleDrawer = status => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setSortDrawer(status);
  };

  return (
    <>
      <AccessLink filterDelete={filterDelete} />
      <div className="sort-box mb-3">
        <InSetBoxShadow className="d-flex align-items-center mb-2 px-2 px-md-3">
          <div style={{ flex: 1, height: "51px" }}>
            {/* <img
            src={window.origin + "/WebSide/assets/images/find.png"}
            alt="امتیاز"
            className="d-none d-lg-inline"
            style={{
              width: "20px",
              height: "20px",
              marginLeft: "25px",
              alignSelf: "center"
            }}
          /> */}
            <div className="d-flex justify-content-start justify-content-lg-start h-100 align-items-center">
              <div className="d-flex justify-content-start justify-content-lg-start h-100 align-items-center">
                <div
                  onClick={() => toggleFilterDialog(true)}
                  className="me-4 me-lg-4 ms-0 d-xl-none"
                >
                  <FilterIcon />
                  <span className="ms-2 d-none d-sm-inline">فیلتر</span>
                </div>
                <div onClick={toggleDrawer(true)} className="d-lg-none">
                  <SortIcon />
                  <span className="ms-2 d-none d-sm-inline">مرتب سازی</span>
                </div>
              </div>
              {sort.map(btn => {
                return (
                  <button
                    key={btn.id}
                    onClick={() => {
                      handleFilter("sort", btn.id);
                    }}
                    className={
                      "sort-btn d-none d-lg-inline-block me-4 " +
                      (getValue("sort") === btn.id ? " sort-btn-active" : "")
                    }
                  >
                    {btn.name}
                  </button>
                );
              })}
            </div>
          </div>

          <h6 className="desc" style={{ fontWeight: "400" }}>
            {!loading && `${count} مجموعه یافت شد`}
          </h6>
        </InSetBoxShadow>
        <Drawer
          open={sortDrawer}
          onClose={toggleDrawer(false)}
          anchor="bottom"
          className="sort-drawer"
        >
          <div className="px-2 py-4">
            <CloseIcon onClick={toggleDrawer(false)} />
            <span className="h6 mx-3">مرتب سازی بر اساس</span>
          </div>
          <ul>
            {sort.map(btn => {
              return (
                <li
                  key={btn.id}
                  onClick={() => {
                    setSortDrawer(false);
                    handleFilter("sort", btn.id);
                  }}
                  className={
                    getValue("sort") === btn.id ? "sort-drawer-item-active" : ""
                  }
                >
                  <span>{btn.name}</span>
                  <CheckIcon />
                </li>
              );
            })}
          </ul>
        </Drawer>
      </div>
    </>
  );
};

export default Sort;
